import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      // Mutations call invalidateQueries() to mark lists stale after
      // adding/editing something, then navigate to the page that shows
      // the list. That page's query has no active observer at the moment
      // of invalidation, so it isn't refetched then and there — it only
      // picks up the fresh data because it's stale when the list page
      // mounts and this (react-query's normal default) is left enabled.
      refetchOnMount: true,
      staleTime: 60 * 1000 * 5, // 5 minutes
    },
  },
});
